import React, { createContext, useState, useEffect } from 'react';
import Services from './services/Services';

export const MallContext = createContext();

export const MallProvider = ({ children }) => {
  const queryParams = new URLSearchParams(window.location.search);

  const [mallInfo, setMallInfo] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('token') || "");
  const [poiID, setPoiID] = useState(() => {
    // localStorage'tan poiID al, yoksa URL'den al
    return localStorage.getItem('poiID') || queryParams.get('poi');
  });
  const [currentServices, setCurrentServices] = useState([]);

  // Bir servis düğümü aktif mi? (yeni ve eski şemayı destekler)
  // Bir servis düğümü aktif mi? (yeni ve eski şemayı destekler)
  const isServiceActive = (node) => {
    if (!node || typeof node !== 'object') return false;

    // --- Yeni şema: status + (daily / hourly / price) ---
    if ('status' in node) {
      const status = !!node.status;

      // pet-car / kid-car için fiyat var mı?
      const hasHourly =
        Array.isArray(node.hourly) && node.hourly.length > 0;
      const hasDaily = !!node.daily;

      // gift için price alanı
      const hasGiftPrice =
        typeof node.price !== 'undefined' && node.price !== null;

      const hasAnyPrice = hasHourly || hasDaily || hasGiftPrice;

      // status true OLMALI + en az bir fiyat tanımı OLMALI
      return status && hasAnyPrice;
    }

    // --- Eski şema ihtimalleri: ---

    // gift: { price, currency }
    if ('price' in node) return node.price != null;

    // saatlik/günlük: { hour: {...}, daily: {...} }
    if (node.hour || node.daily) return true;

    // Bazı durumlarda sadece prices olabilir:
    if (node.prices && typeof node.prices === 'object') {
      return Object.keys(node.prices).length > 0;
    }

    return false;
  };

  const hydrateFromToken = (poi, tok) => {
    const tokStr = typeof tok === 'string' ? tok : String(tok || "");
    if (!tokStr || !tokStr.trim()) return;
    setToken(tokStr);

    Services.GetPoiDetails(tokStr, poi)
      .then((res2) => {
        if (res2.data.status) {
          const result = res2.data.result;
          setMallInfo(result);
          localStorage.setItem("mallTitle", result.mallTitle);

          // currentServices: yalnızca status'u aktif olan (veya eski şemada fiyatı olan) anahtarlar
          const viwp = result?.vehicleInventoryWithPrice;
          if (viwp && typeof viwp === 'object') {
            const activeKeys = Object.entries(viwp)
              .filter(([_, node]) => isServiceActive(node))
              .map(([key]) => key);
            setCurrentServices(activeKeys);
          } else {
            setCurrentServices([]);
          }
        } else {
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const poiFromURL = queryParams.get('poi');

    if (poiFromURL) {
      localStorage.setItem('poiID', poiFromURL);
      setPoiID(poiFromURL);
      const storedToken = localStorage.getItem('token') || '';
      if (storedToken) hydrateFromToken(poiFromURL, storedToken);
    } else if (poiID) {
      // URL'de poi yoksa ama localStorage'da varsa mevcut olanı kullan
      const storedToken = localStorage.getItem('token') || '';
      if (storedToken) hydrateFromToken(poiID, storedToken);
    } else {
      console.warn('poi değeri bulunamadı.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!token || !poiID) return;
    if (mallInfo) return;
    hydrateFromToken(poiID, token);
  }, [token, poiID, mallInfo]);

  return (
    <MallContext.Provider value={{ mallInfo, token, setToken, poiID, currentServices }}>
      {children}
    </MallContext.Provider>
  );
};
